import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
  LOCALE_ID
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import {
  provideHttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { provideEventPlugins  } from '@taiga-ui/event-plugins';

import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';

registerLocaleData(localeRu)

export const appConfig: ApplicationConfig = {
  providers: [
    // ─── Zone.js: coalescing уменьшает количество лишних циклов ChangeDetection
    provideZonelessChangeDetection(),

    // ─── Роутинг ──────────────────────────────────────────────────────────────
    provideRouter(
        routes,

        // Позволяет получать параметры роута (:id) напрямую как @Input() в компоненте,
        // без инжекта ActivatedRoute
        withComponentInputBinding(),

        // Скролл в начало страницы при каждой навигации
        withRouterConfig({ onSameUrlNavigation: 'reload' })
    ),

    // ─── HTTP ─────────────────────────────────────────────────────────────────
    provideHttpClient(
        // Использует нативный fetch вместо XMLHttpRequest (лучше для SSR и производительности)
        withFetch(),

        // Функциональный интерцептор: добавляет Bearer-токен ко всем запросам,
        // обрабатывает 401 (refresh или logout)
        withInterceptors([authInterceptor])
    ),

    // ─── Keycloak (angular-oauth2-oidc) ───────────────────────────────────────
    provideOAuthClient(),

    // ─── Инициализация Keycloak до старта приложения ──────────────────────────
    // Без этого приложение откроется раньше, чем придёт токен и профиль пользователя.
    // APP_INITIALIZER блокирует запуск Angular пока promise не разрешится.
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.initKeycloak();
    }),

    // ─── Анимации Taiga UI ────────────────────────────────────────────────────
    provideAnimations(),
    provideEventPlugins(),
    { provide: LOCALE_ID, useValue: 'ru' }
  ],
};